// extracted by mini-css-extract-plugin
export default {"tepikTeam":"tepik-team_tepikTeam__9DMp6","header":"tepik-team_header__Oos1S","rotate":"tepik-team_rotate__NVwne"};